import { ROOT_SERVER_URL } from '../config';
import { request } from '../utils';
import { setPaginationParams, type PaginationParams } from './pagination';

export type LicensesReportRequest = {
  organizations?: string[];
  expirationDate?: string;
  isPermanent?: boolean;
  isActive?: boolean;
  features?: string[];
};

export type LicensesReportRow = {
  id: string;
  cycle: string;
  expirationDate: string | null;
  features: string[];
  filename: string;
  licenseOwner: {
    id: string;
    name: string;
    organization: {
      id: string;
      name: string;
    };
  };
  ownerId: string;
  templateId: string;
};

export function getLicensesReport(
  params: LicensesReportRequest,
  pagination: PaginationParams
): Promise<{ items: LicensesReportRow[]; count: number }> {
  const urlSearchParams = getLicensesReportSearchParams(params, pagination);

  return request(`${ROOT_SERVER_URL}/api/reports/licenses?${urlSearchParams}`);
}

export function getLicensesReportCsvUrl(params: LicensesReportRequest): string {
  const urlSearchParams = getLicensesReportSearchParams(params);

  return `${ROOT_SERVER_URL}/api/reports/licenses/csv?${urlSearchParams}`;
}

export function getLicensesReportSearchParams(params: LicensesReportRequest, pagination?: PaginationParams) {
  const urlSearchParams = new URLSearchParams();
  params.organizations?.forEach((org) => urlSearchParams.append('organizations', org));

  if (params.expirationDate) {
    urlSearchParams.append('expirationDate', params.expirationDate);
  }

  if (params.isPermanent !== undefined) {
    urlSearchParams.append('isPermanent', params.isPermanent.toString());
  }

  if (params.isActive !== undefined) {
    urlSearchParams.append('isActive', params.isActive.toString());
  }

  params.features?.forEach((feature) => urlSearchParams.append('features', feature));

  if (pagination) {
    setPaginationParams(urlSearchParams, pagination);
  }

  return urlSearchParams;
}
